const ConstructionSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/726c449329866275701a961c0d9fe691.jpeg"
              alt="Construction de bâtiments modernes en Afrique"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
          </div>

          {/* Content */}
          <div>
            <div className="inline-block px-4 py-2 bg-teal-50 rounded-full mb-6">
              <span className="text-teal-600 font-semibold text-sm">5. BÂTIMENT : CONSTRUCTION & ENTRETIEN</span>
            </div>
            
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Construction & Entretien
            </h2>
            
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Notre savoir-faire dans le domaine de la construction nous donne la capacité de mener à bien un large éventail de projets, couvrant aussi bien les structures résidentielles que les complexes industriels sophistiqués.
              </p>
              
              <p>
                Nous proposons une méthodologie globale pour le bâtiment, incluant l'intégralité des phases : de la planification et la conception initiales jusqu'à la gestion du chantier et son exécution finale.
              </p>
              
              <p>
                Notre rigueur extrême dans les finitions, notre attachement indéfectible à la qualité supérieure et le respect strict des calendriers prévisionnels sont les garanties qui nous permettent de livrer des projets réussis, en adéquation parfaite avec les exigences précises de notre clientèle.
              </p>
            </div>

            <div className="mt-8 grid grid-cols-2 gap-4">
              <div className="bg-gradient-to-br from-teal-50 to-teal-100 p-6 rounded-xl">
                <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-building-line text-2xl text-white"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-1">Résidentiel</h4>
                <p className="text-sm text-gray-600">Villas et logements</p>
              </div>
              
              <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-6 rounded-xl">
                <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-community-line text-2xl text-white"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-1">Commercial</h4>
                <p className="text-sm text-gray-600">Bureaux et commerces</p>
              </div>
              
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-6 rounded-xl">
                <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-factory-line text-2xl text-white"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-1">Industriel</h4>
                <p className="text-sm text-gray-600">Usines et entrepôts</p>
              </div>
              
              <div className="bg-gradient-to-br from-green-50 to-green-100 p-6 rounded-xl">
                <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-tools-line text-2xl text-white"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-1">Entretien</h4>
                <p className="text-sm text-gray-600">Maintenance complète</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConstructionSection;